import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";

import { mdiCheck, mdiClose, mdiDeleteForever, mdiPencil } from "@mdi/js";

import { DffSideModule, PanelModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";
import { EBoksTilmeldingModule } from "@e-forsyning/common/e-boks";

import { EjendomsoplysningerComponent } from "./ejendomsoplysninger/ejendomsoplysninger.component";
import { EjeroplysningerComponent } from "./ejeroplysninger/ejeroplysninger.component";
import { LoginoplysningerComponent } from "./loginoplysninger/loginoplysninger.component";
import { MineOplysningerRoutingModule } from "./mine-oplysninger-routing.module";
import { MineOplysningerComponent } from "./mine-oplysninger.component";
import { StamoplysningerComponent } from "./stamoplysninger/stamoplysninger.component";
import { TilknytForbrugerComponent } from "./tilknyt-forbruger/tilknyt-forbruger.component";

@NgModule({
    imports: [
        CommonModule,
        DffSideModule,
        PanelModule,
        EBoksTilmeldingModule,
        MatButtonModule,
        MatExpansionModule,
        MatIconModule,
        MatSelectModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MineOplysningerRoutingModule,
        ReactiveFormsModule
    ],
    declarations: [
        MineOplysningerComponent,
        StamoplysningerComponent,
        EjeroplysningerComponent,
        EjendomsoplysningerComponent,
        LoginoplysningerComponent,
        TilknytForbrugerComponent
    ]
})
export class EForsyningFeaturesMineOplysningerModule {
    constructor(iconRegistry: SvgIconRegistry) {
        iconRegistry.registerIcon(mdiPencil, "mine-oplysninger-edit");
        iconRegistry.registerIcon(mdiCheck, "mine-oplysninger-check");
        iconRegistry.registerIcon(mdiClose, "mine-oplysninger-close");
        iconRegistry.registerIcon(mdiDeleteForever, "mine-oplysninger-delete-forever");
    }
}
